import { clearClient, setClient, setLoading } from 'store/ClientsSlice';
import { useAppDispatch } from 'store/Store';
import useRole from 'hooks/useRole';
import RepresentantService from 'service/apicataleg/api/representant/ClientsRepreService';
import CartRepreService from 'service/apicataleg/api/representant/CartRepreService';

const useClientSelector = () => {
  const dispatch = useAppDispatch();
  const role = useRole();
  const selectClient = async (id: number): Promise<void> => {
    if (role === 'client') return;

    dispatch(setLoading(true));
    await Promise.all([
      RepresentantService.getClientById(id),
      CartRepreService.getClientCarts(id),
      RepresentantService.getClientAddresses(id),
      RepresentantService.getClientMarques(id),
    ]).then(([client, carts, addresses, marques]) => {
      if (client) dispatch(setClient({ client, carts, addresses, marques }));
    });
  };

  const deselectClient = () => {
    dispatch(clearClient());
  };
  return { selectClient, deselectClient };
};

export default useClientSelector;
